module.exports = __webpack_public_path__ + "static/img/culture-5.4fc5dec7.png";